import {Component} from '@angular/core';
import {WizardPageBaseComponent} from '@utils-lib';
import {ActivatedRoute} from '@angular/router';
import {UmsaetzeInternetAngaben} from '@nachdigal';

@Component({
  selector: 'common-ui-umsaetze-internet-angaben',
  templateUrl: './umsaetze-internet-angaben.component.html',
  styleUrls: ['./umsaetze-internet-angaben.component.scss']
})
export class UmsaetzeInternetAngabenComponent extends WizardPageBaseComponent<UmsaetzeInternetAngaben> {

  static nutzdatenPath = 'umsaetzeInternetAngaben';
  static route = 'umsaetze-internet-angaben';

  constructor(protected readonly activatedRoute: ActivatedRoute) {
    super(activatedRoute);
  }

  protected getStammdatenMappingRules(): Map<string, unknown | Array<unknown>> {
    return new Map<string, unknown | Array<unknown>>([]);
  }
}
